/*
 * AppReducer
 *
 * The reducer takes care of our data. Using actions, we can change our application state.
 * To add a new action, add it to the ACTION_HANDLERS object.
 */

import { combineReducers } from 'redux';
import dateSelection from './DateSelection/reducer';
import accommodation from './ChooseAccommodation/reducer';
import confirmation from './Confirmation/reducer';
import { SELF_SERVICE } from 'utils/routeUtils';

// Actions
const START_GO_BACK = 'app/START_GO_BACK';
const COMPLETE_GO_BACK = 'app/COMPLETE_GO_BACK';
export const SET_TOKEN = 'app/SET_TOKEN';
const SET_BOOKING_SOURCE = 'app/DateSelection/SET_BOOKING_SOURCE';
const SET_GUEST_PROFILES = 'app/SET_GUEST_PROFILES';
const SET_BOOKING_COMMENTS = 'app/SET_BOOKING_COMMENTS';
const SET_IN_MOBILE_APP = 'app/DateSelection/SET_IN_MOBILE_APP';

export function startGoBack() {
  return {
    type: START_GO_BACK
  };
}

export function completeGoBack() {
  return {
    type: COMPLETE_GO_BACK
  };
}

export function setToken(token) {
  return {
    type: SET_TOKEN,
    payload: { token }
  };
}

export function setBookingSource(bookingSource) {
  return {
    type: SET_BOOKING_SOURCE,
    payload: { bookingSource }
  };
}

export function setGuestProfiles(profiles) {
  return {
    type: SET_GUEST_PROFILES,
    payload: { profiles }
  };
}

export function setBookingComments(comments) {
  return {
    type: SET_BOOKING_COMMENTS,
    payload: { comments }
  };
}

export function setInMobileApp(inMobileApp) {
  return {
    type: SET_IN_MOBILE_APP,
    payload: { inMobileApp }
  };
}

// Action Handlers
const ACTION_HANDLERS = {
  [START_GO_BACK]: (state, action) =>
    Object.assign({}, state, {
      goingBack: true
    }),
  [COMPLETE_GO_BACK]: (state, action) =>
    Object.assign({}, state, {
      goingBack: false
    }),
  [SET_TOKEN]: (state, { payload }) =>
    Object.assign({}, state, {
      token: payload.token
    }),
  [SET_BOOKING_SOURCE]: (state, action) =>
    Object.assign({}, state, {
      bookingSource: action.payload.bookingSource
        ? action.payload.bookingSource
        : state.bookingSource
    }),
  [SET_GUEST_PROFILES]: (state, action) =>
    Object.assign({}, state, {
      guestProfiles: action.payload.profiles
    }),
  [SET_BOOKING_COMMENTS]: (state, action) =>
    Object.assign({}, state, {
      bookingComments: action.payload.comments
    }),
  [SET_IN_MOBILE_APP]: (state, action) =>
    Object.assign({}, state, {
      inMobileApp: action.payload.inMobileApp
    })
};

// The initial state of the App
const initialState = {
  goingBack: false,
  token: '',
  bookingSource: SELF_SERVICE,
  guestProfiles: null,
  bookingComments: null,
  inMobileApp: false
};

// Reducer
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}

// Combine the global reducer with the route reducers here.
export default combineReducers({
  global: reducer,
  dateSelection,
  accommodation,
  confirmation
});
